import {
    type Component,
    type ComponentInProject,
    type ComponentSourceRaw,
} from '@gql/graphql';
import { type ComponentDetailsViewModel } from '../models/ComponentDetailsViewModel';

export function fromComponent(
    component: Component,
    sourcesData: ComponentSourceRaw[],
): ComponentDetailsViewModel {
    return {
        id: component.id,
        name: component.name,
        version: component.version,
        vendorName: component.componentVendor.name,
        eolDate: component.eolDate,
        eolReached: component.eolReached,
        isValid: component.isValid,
        monitoredSince: component.monitoredSince,
        url: component.url,
        securityUrl: component.securityUrl,
        cpeName: component.cpeName,
        sourcesData,
    };
}

export function fromComponentInProject(
    component: ComponentInProject,
    sourcesData: ComponentSourceRaw[],
): ComponentDetailsViewModel {
    return {
        id: component.id,
        name: component.name,
        version: component.version,
        vendorName: component.componentVendorName,
        eolDate: component.eolDate,
        eolReached: component.eolReached,
        isValid: component.isValid,
        monitoredSince: component.monitoredSince,
        url: component.url,
        securityUrl: component.securityURL,
        cpeName: component.cpeName,
        sourcesData,
    };
}
